import { baseApi } from 'core/api';

const state = () => ({
    _shortener: {
        supportedDomains: [],
        oldDomains: [],
        manualDomains: [],
        marketingDomains: [],
        mainDomain: '',
        customDomain: null,
    },
    _currentShortDomain: null,
    _currentCustomDomain: null,
    _loadingCustomShortDomain: false,
});

const getters = {
    allShortenerDomainNames: (state) => _getAllDomainNames(state._shortener),
    shortenerManualDomains: (state) => state._shortener.manualDomains,
    shortenerMarketingDomains: (state) => state._shortener.marketingDomains,
    currentShortDomain: (state) => state._currentShortDomain,
    shortenerCustomDomain: (state) => state._shortener.customDomain,
    currentCustomDomain: (state) => state._currentCustomDomain,
    isLoadingCustomShortDomain: (state) => state._loadingCustomShortDomain,
};

const actions = {
    getAllShortenerDomains(params) {
        // domains are changed only when ENV variables on the BE side are changed
        if (!params?.forceReload && this.allShortenerDomainNames.length) {
            return this.allShortenerDomainNames;
        }
        return baseApi.get('core/url/shortener/domains').then((response) => {
            const data = response.data || {};

            this._setShortenerDomainsLoaded(data);
            return _getAllDomainNames(data);
        });
    },

    messagesUrlShort(params) {
        if (this._currentShortDomain) {
            params.short_domain = this._currentShortDomain;
        }

        return baseApi.post('core/url/short', params).then((response) => {
            const data = response.data;

            if (data.length) {
                this._setShortenerCurrentDomain(new URL(data[0].shortURL)?.hostname || null);
            }

            return data;
        });
    },

    messagesUrlShortCurrentDomain(domain = null) {
        this._setShortenerCurrentDomain(domain);
    },

    messagesUrlShortReset() {
        this._setShortenerUrlsReset();
    },

    getCustomDomain(hideLoader = false) {
        if (!hideLoader) this._setShortenerCustomDomainLoading(true);

        return baseApi
            .get('core/url/custom-domain/get')
            .then((response) => {
                const data = response.data || {};

                this._setShortenerCustomDomainLoaded(data);

                return data;
            })
            .finally(() => {
                this._setShortenerCustomDomainLoading(false);
            });
    },

    createCustomDomain(params) {
        return baseApi
            .post('core/url/custom-domain/create', params)
            .then((response) => {
                const data = response.data;

                this._setShortenerCustomDomainLoaded(data);

                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },

    updateCustomDomain(data) {
        const params = {
            certificate: data.certificate,
            private_key: data.private_key,
        };

        return baseApi
            .put(`core/url/custom-domain/update/${data.id}`, params)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response?.data;
            });
    },

    verifyCustomDomain({ id }) {
        return baseApi
            .post(`core/url/custom-domain/verify/${id}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response?.data;
            });
    },

    removeCustomDomain({ id }) {
        return baseApi
            .delete(`core/url/custom-domain/${id}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response?.data;
            });
    },

    _setShortenerDomainsLoaded(data) {
        this._shortener.supportedDomains = [...(data.supportedDomains || [])];
        this._shortener.oldDomains = [...(data.oldDomains || [])];
        this._shortener.manualDomains = data.manualDomains || [];
        this._shortener.marketingDomains = data.marketingDomains || [];
        this._shortener.mainDomain = data.mainDomain || '';
    },

    _setShortenerCurrentDomain(domain) {
        this._currentShortDomain = domain;
    },

    _setShortenerUrlsReset() {
        this._currentShortDomain = null;
    },

    _setShortenerCustomDomainLoading(status) {
        this._loadingCustomShortDomain = status;
    },

    _setShortenerCustomDomainLoaded(data) {
        if (data && !Array.isArray(data)) {
            this._currentCustomDomain = [data];
        } else {
            this._currentCustomDomain = [];
        }
    },
};

function _getAllDomainNames(data) {
    if (!data) data = {};

    return [
        ...data.supportedDomains,
        ...data.oldDomains,
        ...data.manualDomains,
        ...data.marketingDomains,
    ];
}

export default {
    state,
    getters,
    actions,
};
